export { default } from "./Solution";
